import socketIOClient from 'socket.io-client';
export const appSocket = socketIOClient.connect(
	`${process.env.REACT_APP_API_URL}`,
	{
		secure: true,
		rejectUnauthorized: false,
	}
);
